// Stores the given value into cookie
// It is important to note that the cvalue has to be of type 'string'
// If you wish to store anything more complex (like an array), parse the thing to json string first
export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;

    document.cookie = `${cname}=${encodeURIComponent(cvalue)};${expires}';path=/`;
}

// Get the value from cookie, the value retrieved will be of type 'string'
export function getCookie(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
            return decodeURIComponent(c.substring(name.length, c.length));
        }
    }
    return '';
}

export function removeCookie(cname) {
    // A cookie is removed when its exp day is set to the past
    setCookie(cname, '', -10);
}
